export default class InputHelper {
  static handleMaskedBackspace(event, maskedChar) {
    // Get cursor position and key code
    const cursorPos = Number(event.target.selectionStart);
    const keyCode = Number(event.keyCode);

    // Only deal with backspace keys that are pressed at the end of the string,
    // when the end of the string has a masked char.  E.g. delete the actual char before the masked char.
    if (
      keyCode === 8 &&
      cursorPos > 0 &&
      cursorPos === event.target.value.length &&
      event.target.value.charAt(cursorPos - 1) === maskedChar
    ) {
      // Disable text mask events for this cursor positions
      event.preventDefault();
      event.stopPropagation();

      // Simulate backspace delete
      event.target.value =
        event.target.value.substring(0, cursorPos - 2) +
        event.target.value.substring(cursorPos, event.target.value.length);
      event.target.setSelectionRange(cursorPos, cursorPos);
    }
  }
}
